import React from 'react';

function Twelve() {
    return (
        <div className="blog-post">
            <h1>Nick Morgan's Visit, Class Reflections, and Navigating Tensions</h1>
            <small>04-20-2026</small>
            <p>
                Nick Morgan's visit left me thinking about how security isn't a layer you bolt on at the end. It's a mindset
                 woven into every decision you make while building. What stood out most was how he framed vulnerability not as
                 a failure of intelligence but as a failure of attention. One of the most intruiging points that Nick made was
                 when he discussed Red Team vs Blue Team; the difference between thinking and acting as an attacker versus a
                 defender of a system.
            </p>
            <br />
            <h2>Reflecting on the Course and Its Tensions</h2>
            <p>
                As a student in this class, I was able to identify benefits and downsides, on weekly basis. A learning
                 goal where this class exceled was improving the student's ability to make decisions about open-ended
                 project, especially when AI is involved. Each week, we were encouraged to consult with our partner
                 BEFORE consulting AI on our project. This gave us a chance to create a list of tasks or a framework
                 for what each aspect of our project will look like. This way, we can get most of the details down and
                 use AI for more technical work or cloudy details.
            </p>
            <p>
                While I enjoyed the decision-making aspect of this class, it failed to challenge me with regards to coordinating
                 needs for "clients". The needs for our Social Network are relatively straight forward, requiring
                 moderately intense code review. An idea for future sessions of this course; each group has to choose one
                 aspect of the project where they will expand extensively using their AI agent. This would allow each group
                 to consider challenging client needs beyond the basic implementation of the project.
            </p>
            <p>
                To me, the mose useful part of this course was the blogging portion. As stated in the course's learning
                 objectives, "humans excel at making tools, but they also need to make words". AI can point a human to almost
                 tool that you could ask for, but what it will always struggle to do is connect with a human. Writing blogs this
                 semester has helped me turn technical thoughts into concrete discussions that can spark human connection. I'm
                 grateful to have improved this skill before I go out into the crazy work and job market that we're living in.
                 Written and verbal communication will always be a valuable skill, no matter what the job market looks like.
            </p>
            <br />
            <h2>Nogramming Assignment</h2>
            <p>
                I have part of my LLM built, I will start putting large pieces together to begin finalizing it.
            </p>
        </div>
    );
}

export default Twelve;
